import { themes as initThemes } from '../MatxTheme/initThemes';
import layout1Settings from './Layout1/Layout1Settings';

export interface Props {
  activeLayout: 'layout1' | 'layout2';
  activeTheme: string; 
  perfectScrollbar: boolean;
  themes: typeof initThemes;
  layout1Settings: typeof layout1Settings;

  secondarySidebar: {
    show: boolean;
    open: boolean;
    theme: string; 
  };

  footer: {
    show: boolean;
    fixed: boolean;
    theme: string; 
  };
}

//change theme here (dark mode)
export const MatxLayoutSettings: Props = {
  activeLayout: 'layout1',
  activeTheme: 'blue',
  perfectScrollbar: false,
  themes: initThemes,
  layout1Settings: layout1Settings,
  secondarySidebar: {
    show: false,
    open: false,
    theme: 'slateDark1',
  },
  footer: {
    show: true,
    fixed: false,
    theme: 'slateDark1',
  },
};
